import {
  isOneApp,
  getOneAppPrimaryColor,
} from '@wix/communities-blog-client-common/dist/src/selectors/search-params-selectors';
import { updateAppSettingsOnStore } from './update-app-settings';
import getOneAppSettings from '../services/get-one-app-settings';

export const overrideSettingsInOneApp = () => (dispatch, getState) => {
  if (isOneApp(getState())) {
    const primaryColor = getOneAppPrimaryColor(getState());
    dispatch(updateAppSettingsOnStore(getOneAppSettings(primaryColor)));
  }
};
